<template>
  <div>
    <div v-if="unit && unit.consumables">
      <DataGrid large large-gap class="pb-5">
        <template v-for="(consumable, i) in unit?.consumables || []" :key="i">
          <ConsumableCardElectrode
            v-if="consumable.type === 'ELECTRODE'"
            :consumable="consumable"
            @on-card-open="openConsumable(consumable)"
          />
          <DialogComponent v-else-if="consumable.type === 'WATER_FILLING'">
            <template #activator="{ toggle }">
              <ConsumableFillingCard
                :water-filling="consumable"
                @on-card-open="toggle"
              />
            </template>
            <ConsumableWaterFillingDetail />
          </DialogComponent>
          <DialogComponent v-else-if="consumable.type === 'HEATING'">
            <template #activator="{ toggle }">
              <ConsumableHeatingCard
                :heating="consumable"
                @on-card-open="toggle"
              />
            </template>
            <ConsumableHeatingDetail />
          </DialogComponent>
          <ConsumableCardChemical
            v-else
            :consumable="consumable"
            @on-card-open="openConsumable(consumable)"
          />
        </template>
      </DataGrid>

      <DialogComponent v-model="openDialog">
        <ConsumableDetail
          v-if="presentedConsumable"
          :consumable-type="presentedConsumable"
        />
      </DialogComponent>
    </div>
    <div v-else>
      <BtnComponent loading block disabled large />
    </div>
  </div>
</template>

<script>
import DataGrid from '@acs/components-library/src/components/deviceDetail/sublayouts/DataGrid.vue';
import ConsumableCardElectrode from '@acs/components-library/src/components/deviceDetail/consumables/ConsumableCardElectrode.vue';
import ConsumableCardChemical from '@acs/components-library/src/components/deviceDetail/consumables/ConsumableCardChemical.vue';
import ConsumableFillingCard from '@acs/components-library/src/components/deviceDetail/consumables/ConsumableFillingCard.vue';
import ConsumableHeatingCard from '@acs/components-library/src/components/deviceDetail/consumables/ConsumableHeatingCard.vue';
import DialogComponent from '@acs/components-library/src/components/common/Dialog.vue';
import ConsumableHeatingDetail from './ConsumableHeatingDetail.vue';
import ConsumableWaterFillingDetail from './ConsumableWaterFillingDetail.vue';
import BtnComponent from '@acs/components-library/src/components/common/Btn.vue';

import { ViewQuery } from '@acs/components-library/src/gql/live/UnitDetailConsumables.js';
import ConsumableDetail from './ConsumableDetail.vue';

export default {
  components: {
    ConsumableDetail,
    DialogComponent,
    ConsumableHeatingCard,
    ConsumableFillingCard,
    ConsumableCardChemical,
    ConsumableCardElectrode,
    ConsumableHeatingDetail,
    ConsumableWaterFillingDetail,
    DataGrid,
    BtnComponent,
  },
  props: {
    sn: {
      type: String,
      required: true,
    },
    unpaired: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      presentedConsumable: null,
    };
  },
  apollo: {
    unitBySerialNumber: {
      query: ViewQuery,
      variables() {
        return { sn: this.sn };
      },
      skip() {
        return this.unpaired || !this.sn;
      },
    },
  },
  computed: {
    unit() {
      return this.unitBySerialNumber;
    },
    openDialog: {
      get() {
        return !!this.presentedConsumable;
      },
      set(dialog) {
        if (dialog === false ) {
          this.presentedConsumable = null;
        }
      },
    },
  },
  methods: {
    openConsumable(consumable) {
      console.log('openConsumable', consumable);
      this.presentedConsumable = consumable.type;
      // this.$router.push({ name: 'ConsumableDetail', params: { sn: this.sn, consumable: consumable.type } });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
